import CustomSelect from "components/custom-select/CustomSelect";
import {
  ElementViewForClipboardProps,
  ElementViewProps,
} from "../AtomicElementView";
import styles from "./DropdownContent.module.scss";

function parseRawData(data: any, element: DropdownElement) {
  // We expect a string containing an option title, but we want to also be able to handle:
  // - an array of strings (all but the first will be ignored), or
  // - an id instead of a title

  if (!data) {
    return "";
  }

  const value = Array.isArray(data) ? data[0] : data.toString();
  const option = element.options.find(
    (option) => option.title === value || option.id === value,
  );
  return option?.title ?? "";
}

export function DropdownContentForClipboard({
  data: rawData,
  element,
}: ElementViewForClipboardProps<DropdownElement>) {
  const data = parseRawData(rawData, element);
  return (
    <ul>
      <li>{data || "No answer"}</li>
    </ul>
  );
}

export default function DropdownContent({
  data: rawData,
  element,
  onChange,
  isLocked,
  isPrintMode,
  disabled,
  showAsMissing,
}: ElementViewProps<DropdownElement>) {
  const data = parseRawData(rawData, element);

  if (isPrintMode) {
    return (
      <ul className={styles.print}>
        <li>{data || "No answer"}</li>
      </ul>
    );
  }

  return (
    <div className={styles.container}>
      <CustomSelect
        value={data ? { value: data, label: data } : null}
        placeholder="Choose"
        options={element.options.map((option) => ({
          value: option.title,
          label: option.title,
        }))}
        onChange={({ value }) => onChange(value)}
        disabled={disabled || isLocked}
        useNotesAndFormsV2Styles
        menuPortalTarget={document.body}
        showAsInvalid={showAsMissing && !data}
      />
    </div>
  );
}
